<script>
  import { onMount } from 'svelte';
  import MainDialog from './components/dialogs/Main/MainDialog.svelte';
  import { showDialog } from './store/common';

  onMount(() => {
    const button = document.getElementById('anzolo-widget-button');

    const setIsShowDialog = () => {
      showDialog.set(true);
    };

    button.addEventListener('click', setIsShowDialog);

    return () => {
      button.removeEventListener('click', setIsShowDialog);
    };
  });
</script>

<MainDialog />

<style>
</style>
